import React from 'react';
import {FormattedMessage} from 'react-intl';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import {usePaymentBitContext} from '../../contexts/PaymentBitContext';
import styles from './ButtonSubmitBit.module.scss';

const ButtonSubmitBit = () => {
  const {loading} = usePaymentBitContext();

  return (
    <div className={styles.buttonSubmitContainer}>
      <ButtonAction
        variant={'button'}
        type={'submit'}
        label={(
          <FormattedMessage
            id={'payment-form-submitBtn'}
            defaultMessage={'Create link'}
          />
        )}
        customClassnames={{container: styles.button}}
        disabled={loading}
      />
    </div>
  );
};

export default ButtonSubmitBit;
